import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  fetchCompanyStripeSubscriptionsFailure,
  fetchCompanyStripeSubscriptionsSuccess
} from "../slices/features/stripeSubscription";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* fetchCompanyStripeSubscriptionsSaga(action: any) {
  const { payload } = action;
  const { id } = payload;

  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.fetchCompanyStripeSubscriptions,
      baseUrl,
      id,
    );

    yield put(fetchCompanyStripeSubscriptionsSuccess({ ...response }));

    let subscriptionsData = [];
    if (response.data) {
      subscriptionsData = response.data;
    }

    payload?.cbSuccess && payload?.cbSuccess(subscriptionsData);
  } catch (error: any) {
    const { statusCode, statusText } = error;
    yield put(fetchCompanyStripeSubscriptionsFailure({ statusCode, statusText }));
  }
}

export function* watchFetchCompanyStripeSubscriptions() {
  yield takeLatest(
    RequestTypes.FETCH_COMPANY_STRIPE_SUBSCRIPTIONS_REQUEST,
    fetchCompanyStripeSubscriptionsSaga
  );
}
